module.exports = __webpack_public_path__ + "static/media/Drive.211d916a.png";